module.exports = {
          srcSet: "/_next/static/images/img-informatique@2x-160-972e543fec5f3a8b2d230e51cf5ae526.webp"+" 160w"+","+"/_next/static/images/img-informatique@2x-292-07fb579bd4c221f5b23c4bca3e824f82.webp"+" 292w",
          images:[ {path: "/_next/static/images/img-informatique@2x-160-972e543fec5f3a8b2d230e51cf5ae526.webp",width: 160,height: 137},{path: "/_next/static/images/img-informatique@2x-292-07fb579bd4c221f5b23c4bca3e824f82.webp",width: 292,height: 250}],
          src: "/_next/static/images/img-informatique@2x-160-972e543fec5f3a8b2d230e51cf5ae526.webp",
          toString:function(){return "/_next/static/images/img-informatique@2x-160-972e543fec5f3a8b2d230e51cf5ae526.webp"},
          placeholder: undefined,
          width: 160,
          height: 137
      }